import React, { ElementType, forwardRef } from "react";

import { Typography, TypographyProps } from "@mui/material";

export interface IgTypographyProps extends TypographyProps {
  component?: ElementType | undefined;
}

/**
 * @see Typography
 */
export const IgTypography = forwardRef<HTMLSpanElement, IgTypographyProps>(
  (props, ref) => {
    const { children, component, ...rest } = props;

    return (
      <Typography ref={ref} {...rest} component={component ?? "span"}>
        {children}
      </Typography>
    );
  }
);
